import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Stopwatch from "./stopwatch";
import CustomPaginationActionsTable from "./tasks";
import Settings from "./settings";
import Payments from "./paymentslog";
import Report from "./reports";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 5) {
      props.auth.signOut();
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Home" {...a11yProps(0)} />
          <Tab label="Logged Time" {...a11yProps(1)} />
          <Tab label="Logged Payments" {...a11yProps(2)} />
          <Tab label="Reports" {...a11yProps(3)} />
          <Tab label="Settings" {...a11yProps(4)} />
          <Tab label="Logout" {...a11yProps(5)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Stopwatch firestore={props.firestore} auth={props.auth} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CustomPaginationActionsTable
          firestore={props.firestore}
          auth={props.auth}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Payments firestore={props.firestore} auth={props.auth} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Report firestore={props.firestore} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Settings firestore={props.firestore} />
      </TabPanel>
    </div>
  );
}
